import { render, staticRenderFns } from "./rows-editor.vue?vue&type=template&id=f01e12c8&scoped=true&"
import script from "./rows-editor.vue?vue&type=script&lang=js&"
export * from "./rows-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01e12c8",
  null
  
)

export default component.exports